
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import _ from 'lodash'
import '../static/iconfont/iconfont.css'
import '@/scss/base.scss'
import '@/scss/app.scss'
import 'element-ui/lib/theme-chalk/index.css';
import  "@/common/gt.js"
import skyRequest from 'skytech-request'
import commonFn from '@/common/commonFn'
Vue.use(ElementUI)
window.ElementUI = ElementUI
skyRequest.install(function (status, message) {
  commonFn.tipPop.error(message)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  methods: {
  },
  mounted() {
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js